export const SET_MODAL = "SET_MODAL";
export const CLEAR_MODAL = "CLEAR_MODAL";

export const MODAL_UP_AND_GO = "MODAL_UP_AND_GO";
